import { useTranslation } from 'react-i18next';
import { FileText, X } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { FileUpload } from '@/shared/ui/file-upload';

interface FileUploadSectionProps {
  file: File | null;
  onFileSelect: (files: FileList) => void;
  onFileRemove: () => void;
  disabled?: boolean;
}

export function FileUploadSection({ file, onFileSelect, onFileRemove, disabled }: FileUploadSectionProps) {
  const { t } = useTranslation();

  const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  return (
    <div className="grid gap-2">
      {!file ? (
        <FileUpload
          accept=".pdf,image/*"
          multiple={false}
          onFilesSelected={onFileSelect}
          disabled={disabled}
          className="h-32"
        />
      ) : (
        <div className="flex items-center justify-between p-3 bg-gray-50 border border-gray-200 rounded-lg">
          <div className="flex items-center gap-2">
            <FileText className="h-5 w-5 text-gray-600" />
            <span className="text-sm text-gray-700 truncate max-w-[300px]">{file.name}</span>
            <span className="text-xs text-gray-500">({formatFileSize(file.size)})</span>
          </div>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={onFileRemove}
            disabled={disabled}
            className="h-8 w-8 p-0">
            <X className="h-4 w-4" />
          </Button>
        </div>
      )}
      <p className="text-xs text-gray-500">{t('newcmr.add.attachment.file.type.label')}</p>
    </div>
  );
}
